<template>
  <div
    class="row-checkbox"
    @click.stop="onChange"
  >
    <img
      :src="iconSrc"
      width="20"
      height="20"
      alt=""
      draggable="false"
    >
  </div>
</template>

<script>
const CHECKED_ICON_SRC = '/img/icons/checkbox-checked-icon.svg'
const BASE_ICON_SRC = '/img/icons/checkbox-base-icon.svg'

/**
 * The tick of a single row.
 *
 * A listing can hold thousands of rows, and every one of them carries one of these -
 * which is why this is a component of its own rather than the shared Checkbox: it
 * reads its own entry out of the selection state, so ticking a row re-renders that
 * row's box alone instead of the whole table body. The shared Checkbox would also
 * bring a `v-img` per row, and a few thousand of those - each with its own
 * intersection observer - is what made a single tick take seconds.
 *
 * `selectionState` is handed over whole rather than as a ready boolean on purpose:
 * a boolean prop would have to be worked out by the body while it renders, which is
 * exactly the dependency this component exists to keep out of there.
 */
export default {
  name: 'TableRowCheckbox',

  props: {
    selectionState: {
      type: Object,
      required: true,
      default: () => ({})
    },
    rowKey: {
      type: [String, Number],
      default: null
    }
  },

  emits: [
    'change'
  ],

  computed: {
    isChecked () {
      if (this.rowKey === null || this.rowKey === undefined) {
        return false
      }

      return !!this.selectionState[this.rowKey]
    },

    iconSrc () {
      return this.isChecked ? CHECKED_ICON_SRC : BASE_ICON_SRC
    }
  },

  methods: {
    onChange () {
      this.$emit('change', !this.isChecked)
    }
  }
}
</script>

<style scoped lang="scss">
.row-checkbox {
  display: flex;
  align-items: center;
}

.row-checkbox:hover {
  cursor: pointer;
}

/* The same gap the shared Checkbox puts between its box and its label (`mr-2`),
   kept so the column keeps the width it had. */
.row-checkbox img {
  object-fit: contain;
  margin-right: 8px;
}
</style>
